export const BEGIN_AJAX_CALL = 'BEGIN_AJAX_CALL';
export const AJAX_CALL_ERROR = 'AJAX_CALL_ERROR';


export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';

export const REGISTRATION_SUCCESS = 'REGISTRATION_SUCCESS';
export const LOAD_USERS_SUCCESS = 'LOAD_USERS_SUCCESS';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const SELECT_USER = 'SELECT_USER';
export const SELECT_ALL_USER = 'SELECT_ALL_USER';
export const DELETE_USERS_SUCCESS = 'DELETE_USERS_SUCCESS';

export const LOAD_TURNS_SUCCESS = 'LOAD_TURNS_SUCCESS';
export const UPDATE_TURN_SUCCESS = 'UPDATE_TURN_SUCCESS';
export const SELECT_TURN = 'SELECT_TURN';
export const SELECT_ALL_TURN = 'SELECT_ALL_TURN';
export const DELETE_TURNS_SUCCESS = 'DELETE_TURNS_SUCCESS';

export const LOAD_TESTS_SUCCESS = 'LOAD_TESTS_SUCCESS';
export const UPDATE_TEST_SUCCESS = 'UPDATE_TEST_SUCCESS';
export const SELECT_TEST = 'SELECT_TEST';
export const SELECT_ALL_TEST = 'SELECT_ALL_TEST';

export const SIGN_UP_TO_TURN_SUCCESS = 'SIGN_UP_TO_TURN_SUCCESS';
export const GET_CURRENT_TURN_SUCCESS = 'GET_CURRENT_TURN_SUCCESS';

export const UPDATE_SIGNUP_DATA_SUCCESS = 'UPDATE_SIGNUP_DATA_SUCCESS';
export const LOAD_SIGNUP_DATAS_SUCCESS = 'LOAD_SIGNUP_DATAS_SUCCESS';

export const GET_USER_TEST_SUCCESS = 'GET_USER_TEST_SUCCESS';
export const UPDATE_USER_TEST_SUCCESS = 'UPDATE_USER_TEST_SUCCESS';
export const LOAD_USER_SIGNUP_TEST_SUCCESS = 'LOAD_USER_SIGNUP_TEST_SUCCESS';

export const UPLOAD_SIGNUP_STATEMENT_SUCCESS = 'UPLOAD_SIGNUP_STATEMENT_SUCCESS';
export const GET_SIGNUP_STATEMENT_SUCCESS = 'GET_SIGNUP_STATEMENT_SUCCESS';

export const FINALIZE_SIGNUP_SUCCESS = 'FINALIZE_SIGNUP_SUCCESS';
export const FINALIZE_SIGNUP_FAILED = 'FINALIZE_SIGNUP_FAILED';
export const GET_USER_TURN_SUCCESS = 'GET_USER_TURN_SUCCESS';

export const ACCEPT_SIGNUP_STATEMENTS_SUCCESS = 'ACCEPT_SIGNUP_STATEMENTS_SUCCESS';
export const ACCEPT_SIGNUP_STATEMENT_SUCCESS = 'ACCEPT_SIGNUP_STATEMENT_SUCCESS';
export const ADMIN_SELECT_TURN = 'ADMIN_SELECT_TURN';

export const LOAD_TURN_MEMBERS_SUCCESS = 'LOAD_TURN_MEMBERS_SUCCESS';
export const LOAD_USER_SUCCESS = 'LOAD_USER_SUCCESS';
export const REMOVE_PROGRESS_SUCCESS = 'REMOVE_PROGRESS_SUCCESS';
export const SET_PROGRESS_SUCCESS = 'SET_PROGRESS_SUCCESS';


export const LOAD_FILTERS_SUCCESS = 'LOAD_FILTERS_SUCCESS';
export const UPDATE_FILTER_SUCCESS = 'UPDATE_FILTER_SUCCESS';
export const DELETE_FILTER_SUCCESS = 'DELETE_FILTER_SUCCESS';

export const LOAD_PORTAL_SETTINGS_SUCCESS = 'LOAD_PORTAL_SETTINGS_SUCCESS';
export const SAVE_PORTAL_SETTINGS_SUCCESS = 'SAVE_PORTAL_SETTINGS_SUCCESS';

export const MAILCHIMP_EXPORT_SUCCESS = 'MAILCHIMP_EXPORT_SUCCESS';

export const SET_AGREEMENT_NOTE_SUCCESS = 'SET_AGREEMENT_NOTE_SUCCESS';

export const SET_SIGNUPDATA_SCORE="SET_SIGNUPDATA_SCORE";

export const SEND_MESSAGE_SUCCESS="SEND_MESSAGE_SUCCESS";









/** WEBPACK FOOTER **
 ** ./client/actions/actionTypes.js
 **/